// src/constants/support.ts

export const SUPPORT_CONTACTS = {
  // Main support contact for general inquiries
  SUPPORT_PHONE: "+91 75599 78356",
  
  // Trainer contact for messaging after booking
  TRAINER_PHONE: "+91 9037511920",
} as const;

/**
 * Opens WhatsApp with the specified phone number
 * @param phoneNumber - The phone number to open WhatsApp with
 */
export const openWhatsApp = (phoneNumber: string) => {
  // Format phone number for WhatsApp (remove any non-digit characters)
  const formattedNumber = phoneNumber.replace(/\D/g, '');
  // Always use wa.me for consistency
  window.open(`https://wa.me/${formattedNumber}`, '_blank');
};

/**
 * Opens the main support WhatsApp contact
 */
export const openSupportWhatsApp = () => {
  window.open("https://wa.me/917559978356", "_blank");
};

/**
 * Opens the trainer WhatsApp contact
 */
export const openTrainerWhatsApp = (phoneNumber: string) => {
  openWhatsApp(phoneNumber);
};
